import { render } from "./x2_awa_is.vue?vue&type=template&id=311b44c9&scoped=true"
import script from "./x2_awa_is.vue?vue&type=script&lang=js"
export * from "./x2_awa_is.vue?vue&type=script&lang=js"

import "./x2_awa_is.vue?vue&type=style&index=0&id=311b44c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311b44c9"]])

export default __exports__